export type SubitemTemplateDefaults = {
  sampleCount: string;
  sampledLocations: string;
  findings: string;
};

export const REPORT_TEMPLATE_PREFILL_EXCEPTIONS: Record<string, string> = {
  "item-04-sub-03": "报告模板标注为“不涉及”，默认不预填。",
  "item-05-sub-06": "报告模板标注为“不涉及”，默认不预填。",
  "item-05-sub-07": "报告模板标注为“不涉及”，默认不预填。",
  "item-08-sub-04": "报告模板标注为“不涉及”，默认不预填。",
  "item-16-sub-01": "报告模板整项标注为“不涉及”，默认不预填。",
  "item-16-sub-02": "报告模板整项标注为“不涉及”，默认不预填。",
};

export const REPORT_TEMPLATE_DEFAULTS: Record<string, SubitemTemplateDefaults> = {
  "item-01-sub-01": {
    sampleCount: "2",
    sampledLocations: "25#楼、29#楼",
    findings:
      "根据本工程设计文件：25#楼，剪力墙结构，耐火等级二级，建筑高度32.8米，使用性质为二类高层住宅建筑，地上11层，地下0层，建筑面积7560㎡；25#楼，剪力墙结构，耐火等级二级，建筑高度19.05米，使用性质为多层住宅建筑，地上6层，地下0层，建筑面积7260㎡。",
  },
  "item-01-sub-02": {
    sampleCount: "2",
    sampledLocations: "25#楼、地下汽车库",
    findings:
      "根据本工程设计文件：25#楼，剪力墙结构，耐火等级二级。地下汽车库，耐火等级一级。主要构件均为不燃材料。",
  },
  "item-02-sub-01": {
    sampleCount: "全部",
    sampledLocations: "全部",
    findings: "根据规划测绘报告，本工程所申报的建筑单体之间防火间距符合设计文件要求。",
  },
  "item-02-sub-02": {
    sampleCount: "全部",
    sampledLocations: "全部",
    findings:
      "本工程采用环形消防车道，车道净宽与净高均不小于4米，回车场尺寸、转弯半径符合消防设计文件要求，未见树木等障碍物。经查看竣工图，坡度、承载力均符合设计文件要求。",
  },
  "item-02-sub-03": {
    sampleCount: "2",
    sampledLocations: "25#楼、29#楼",
    findings:
      "消防车登高面位于建筑北侧，未见有影响登高救援的裙房，首层设置楼梯出口，登高面各楼层设置消防救援口，净高、净宽不小于1m，窗口据地平不大于1.2m。",
  },
  "item-02-sub-04": {
    sampleCount: "全部",
    sampledLocations: "全部",
    findings:
      "设置的长度、宽度、坡度、承载力均符合经消防设计审查的设计文件，未见有影响登高救援的树木、架空管线。",
  },
  "item-03-sub-01": {
    sampleCount: "1",
    sampledLocations: "本工程消防控制室",
    findings:
      "本工程消防控制室位于地下1层防火分区9，根据本工程设计文件，消防控制室采用耐火极限不低于2h的防火墙、1.5h的楼板、甲级防火门与建筑的其他部分完全分隔，安全出口可直通室外，采用抬高门槛的方式做为防淹措施，采用辅助照明作为应急照明。",
  },
  "item-03-sub-02": {
    sampleCount: "1",
    sampledLocations: "本工程消防水泵房",
    findings:
      "本工程消防控制室位于地下1层防火分区13，根据本工程设计文件，消防水泵房采用设计耐火极限不小于2小时的隔墙与设计耐火极限不小于1.5小时楼板与建筑其他部位分隔。消防水泵房设有排水沟做为防淹措施，设有1个疏散门，均采用平开式甲级钢制防火门，现场应急照明正常。",
  },
  "item-03-sub-03": {
    sampleCount: "2",
    sampledLocations: "锅炉房、空调机房",
    findings:
      "锅炉房、空调机房均位于地下1层防火分区13，根据本工程设计文件，消防水泵房采用设计耐火极限不小于2小时的隔墙与设计耐火极限不小于1.5小时楼板与建筑其他部位分隔。设有1个疏散门，均采用平开式甲级钢制防火门。",
  },
  "item-04-sub-01": {
    sampleCount: "2",
    sampledLocations: "本工程设计文件；材料的质量证明文件",
    findings:
      "根据本工程设计文件，本工程外墙保温材料，首层采用岩棉，燃烧性能为A级，其它层采用石墨聚苯乙烯，燃烧性能为B1级。",
  },
  "item-04-sub-02": {
    sampleCount: "2",
    sampledLocations: "本工程设计文件；材料的质量证明文件",
    findings: "根据本工程设计文件，本工程屋面保温材料采用挤塑板，燃烧性能为B1级。",
  },
  "item-04-sub-03": {
    sampleCount: "",
    sampledLocations: "",
    findings: "",
  },
  "item-05-sub-01": {
    sampleCount: "2",
    sampledLocations: "30#楼3单元2层、31#楼单元2层3",
    findings: "顶棚采用无机涂料，燃烧性能为A级，墙面、地面采用地砖，燃烧性能A级。",
  },
  "item-05-sub-02": {
    sampleCount: "2",
    sampledLocations: "30#楼3单元2层、31#楼单元2层3",
    findings: "地面采用地毯，燃烧性能B1级。",
  },
  "item-05-sub-03": {
    sampleCount: "2",
    sampledLocations: "30#楼3单元2层、31#楼单元2层3",
    findings: "地面采用木地板，燃烧性能B1级。",
  },
  "item-05-sub-04": {
    sampleCount: "2",
    sampledLocations: "30#楼3单元2层、31#楼单元2层3",
    findings: "地面采用地胶，燃烧性能B1级。",
  },
  "item-05-sub-05": {
    sampleCount: "2",
    sampledLocations: "30#楼3单元2层、31#楼单元2层3",
    findings: "墙面采用复合板，燃烧性能B1级。",
  },
  "item-05-sub-06": {
    sampleCount: "",
    sampledLocations: "",
    findings: "",
  },
  "item-05-sub-07": {
    sampleCount: "",
    sampledLocations: "",
    findings: "",
  },
  "item-05-sub-08": {
    sampleCount: "2",
    sampledLocations: "25#楼2层、26#楼2层室内消火栓",
    findings: "抽查部位顶棚、墙面、地面装修材料不影响消防设施使用功能。",
  },
  "item-05-sub-09": {
    sampleCount: "2",
    sampledLocations: "2#号楼201、3#号楼202",
    findings: "抽查部位顶棚、墙面、地面装修材料不影响疏散设施净宽及疏散功能。",
  },
  "item-06-sub-01": {
    sampleCount: "2",
    sampledLocations: "地下1层防火分区7、防火分区13",
    findings: "采用防火墙、防火卷帘、甲级防火门与建筑的其他部分完全分隔，防火封堵严密，防火分隔完整。",
  },
  "item-06-sub-02": {
    sampleCount: "2",
    sampledLocations: "地下1层防火分区7与防火分区2交汇处；地下2层防火分区13与防火分区8交汇处",
    findings: "防火墙设置于防火分区之间，防火分隔完整，防火封堵良好，燃烧性能为不燃材料。",
  },
  "item-06-sub-03": {
    sampleCount: "2",
    sampledLocations: "26#楼地下1层楼梯间防火门；地下1层防火分区9西南侧排烟机房防火门",
    findings:
      "楼梯间防火门采用钢制平开乙级防火门，防火门组件齐全安装牢固，现场实测其自闭功能正常。排烟机房采用钢制平开甲级防火门，防火门组件齐全安装牢固，现场实测其自闭功能正常。",
  },
  "item-06-sub-04": {
    sampleCount: "2",
    sampledLocations: "2层、6层强电井",
    findings:
      "根据本工程设计文件，抽查部位竖向管道井壁耐火极不小于1小时，管井内线缆槽盒及楼层间缝隙封堵完整，强电井采用丙级防火门。",
  },
  "item-06-sub-05": {
    sampleCount: "2",
    sampledLocations: "25#楼南侧2单元201与301窗槛墙；19#楼2单元102与202窗槛墙",
    findings: "抽查点位窗槛墙高度不小于1.2m，符合设计文件要求。",
  },
  "item-07-sub-01": {
    sampleCount: "2",
    sampledLocations: "喷漆间、燃气调压室",
    findings: "采用xxx作为泄压设施，泄压口面积、泄压形式与设计文件相符。",
  },
  "item-07-sub-02": {
    sampleCount: "2",
    sampledLocations: "喷漆间、燃气调压室",
    findings: "防静电、防积聚、防流散措施与设计文件相符。",
  },
  "item-08-sub-01": {
    sampleCount: "全部/2",
    sampledLocations: "全部/1#楼2层前室、3#楼4层前室",
    findings:
      "本工程报验范围内安全出口的形式与数量与设计文件一致。抽查点位前室位置和数量与设计文件相符，未见管道穿越疏散楼梯间、前室处及门窗洞口，防火分隔完整；地下室与地上层共用楼梯，在首层采用耐火极限不低于2h的防火隔墙和乙级防火门将地下部分与地上部分的连通部位完全分隔，经测量疏散宽度、建筑疏散距离、前室面积与设计文件相符。",
  },
  "item-08-sub-02": {
    sampleCount: "2",
    sampledLocations: "27#楼1单元疏散外门、25#楼2单元疏散外门",
    findings: "抽查部位疏散门均为平开式，向疏散方向开启，宽度不小于1.1米，净高度不低于2.1m。",
  },
  "item-08-sub-03": {
    sampleCount: "2",
    sampledLocations: "30#楼2层3单元疏散走道、31#楼2层3单元疏散走道",
    findings: "走道无需设置排烟设施，疏散宽度、疏散距离符合设计文件要求。",
  },
  "item-08-sub-04": {
    sampleCount: "",
    sampledLocations: "",
    findings: "",
  },
  "item-08-sub-05": {
    sampleCount: "4",
    sampledLocations: "变配电室内、防火分区1内1B防烟分区，25轴交S轴与25轴交R轴疏散指示标志，28轴交T轴与29轴交T轴疏散指示标志",
    findings:
      "抽查部位应急照明灯具及疏散指示标志采用A型灯具，安装牢固，外观无机械损伤，工作正常，在抽查部位进行火灾自动报警系统联动测试过程中，相关灯具均能自动进行应急工作状态。抽查部位疏散指示标志灯具，工作正常，安装牢固，外观无机械损伤，指向正确。25轴交S轴与25轴交R轴疏散指示标志，间距7.2m，28轴交T轴与29轴交T轴疏散指示标志间距9.5m。",
  },
  "item-09-sub-01": {
    sampleCount: "2",
    sampledLocations: "3层防火分区1、2层防火分区5",
    findings:
      "每个防火分区设置一部消防电梯，位置、数量与设计文件相符；前室疏散门采用钢制乙级防火门，向疏散方向开启，经测量前室的使用面积不小于6㎡；竣工图显示，井壁采用耐火极限不低于2h的防火隔墙，消防电梯机房采用耐火极限不低于2h的防火隔墙、甲级防火门与建筑的其他部分完全分隔，经测试消防电梯的联动功能正常；消防电梯载重量不大于800kg、电梯井的防水排水功能正常，经测试消防电梯从首层至顶层的运行时间不大于60s，专用对讲电话和专用的操作按钮功能正常，轿厢内采用不燃装修材料。",
  },
  "item-10-sub-01": {
    sampleCount: "2",
    sampledLocations: "建设单位提供供水证明、13号楼南侧给水管道、25号楼北侧给水管道",
    findings: "由两个不同方向的两条市政路市政自来水管网分别引入管径为DN200市政给水。",
  },
  "item-10-sub-02": {
    sampleCount: "1",
    sampledLocations: "消防水泵房",
    findings: "消防水池设置在地下车库消防水泵房内，在水泵房及消防控制室内设置液位显示装置，储存有室内消火栓及喷淋的消防用水，有效容积为234m3。",
  },
  "item-10-sub-03": {
    sampleCount: "2",
    sampledLocations: "消防水泵房",
    findings: "采用自灌式吸水消防泵，1用1备。流量为15L/s，工作泵、备用泵、吸水管、出水管及出水管上的泄压阀、水锤消除设施、截止阀、信号阀等的规格、型号、数量，消防水泵启动控制装置与原图纸一致并符合相关规范要求，吸水管、出水管上的控制阀锁定在常开位置。",
  },
  "item-10-sub-04": {
    sampleCount: "2",
    sampledLocations: "消防水泵房",
    findings:
      "抽查点位室内消火栓采用湿式消火栓，室内消火栓管道成环状管网，室内消火栓系统通过消防水池和消防泵房进行供水，消火栓管道采用热浸锌镀锌钢管。管径≤DN50采用丝扣连接，管径＞DN50采用沟槽连接件连接。",
  },
  "item-10-sub-05": {
    sampleCount: "4",
    sampledLocations: "26号楼南侧室外消火栓、25号楼北侧室外消火栓；地下车库防火分区3的20轴交BD轴室内消火栓、20轴交BJ轴室内消火栓",
    findings:
      "室外消火栓水源为市政供水，室外消火栓采用SS100/65-1.6型地上消火栓，地库室内消火栓设置为SNW65-I型，消火栓安装牢固，外观无机械损伤，消火栓标识清晰准确，组件齐全。室内消火栓间距不大于25m，栓口距地面距离1.1m。",
  },
  "item-10-sub-06": {
    sampleCount: "1",
    sampledLocations: "25号楼屋顶",
    findings: "抽查部位为二类高层住宅，在屋顶最不利点，同时由3个消火栓、3条水枪射出充实水柱，现场实测消火栓动压不低于0.35Mpa。",
  },
  "item-11-sub-01": {
    sampleCount: "2",
    sampledLocations: "地库防火分区3的20轴交BD轴室内消火栓箱，20轴交BJ轴室内消火栓箱",
    findings: "灭火器设置于该场所消火栓箱内，每个灭火器配置点位配置有两具MFZ/ABC4手提干粉灭火器。",
  },
  "item-11-sub-02": {
    sampleCount: "2",
    sampledLocations: "22轴交A、E轴室内消火栓箱，26轴交A、E轴室内消火栓箱",
    findings: "灭火器设置于该场所消火栓箱内，每个灭火器配置点位配置有两具MFZ/ABC4手提干粉灭火器，中危险级，指针在绿区。",
  },
  "item-12-sub-01": {
    sampleCount: "1",
    sampledLocations: "建设单位提供供水证明",
    findings: "由两个不同方向的两条市政路市政自来水管网分别引入管径为DN200市政给水。",
  },
  "item-12-sub-02": {
    sampleCount: "1",
    sampledLocations: "消防水泵房",
    findings: "消防水池设置在地下车库消防水泵房内，在水泵房及消防控制室内设置液位显示装置，储存有室内消火栓及喷淋的消防用水，有效容积为234m3。",
  },
  "item-12-sub-03": {
    sampleCount: "2",
    sampledLocations: "消防水泵房",
    findings: "采用自灌式吸水消防泵，1用1备。流量为35L/s，工作泵、备用泵、吸水管、出水管及出水管上的泄压阀、水锤消除设施、截止阀、信号阀等的规格、型号、数量，消防水泵启动控制装置与原图纸一致并符合相关规范要求，吸水管、出水管上的控制阀锁定在常开位置。",
  },
  "item-12-sub-04": {
    sampleCount: "2",
    sampledLocations: "地下车库防火分区3报警阀室",
    findings: "防火分区3、5、6预作用报警阀组位于地下车库防火分区3报警阀室内，预作用阀组组件齐全，联动测试电磁阀动作，报警阀阀瓣打开，压力开关动作，水力警铃动作，消防水泵启动，有信号反馈，报警阀室内设有排水设施。",
  },
  "item-12-sub-05": {
    sampleCount: "5",
    sampledLocations: "防火分区3报警阀室前、排烟管道",
    findings: "抽查部位采用公称温度68度的直立型喷头及干式下垂型喷头，其周边没有影响其使用的障碍物，喷头间距2.6m。",
  },
  "item-12-sub-06": {
    sampleCount: "1",
    sampledLocations: "地下一层防火分区3",
    findings: "联动测试时，报警阀、水力警铃、水流指示器、压力开关、雨淋阀均正常动作，末端在120秒内完成充水。消防水泵的远程手动、压力开关连锁启动功能正常。",
  },
  "item-13-sub-01": {
    sampleCount: "1",
    sampledLocations: "该项目",
    findings: "依据图纸，本工程采用集中型火灾自动报警系统。",
  },
  "item-13-sub-02": {
    sampleCount: "4",
    sampledLocations: "地下车库防火分区3感烟探测器、手动报警按钮；25号楼4层感烟探测器、手动报警按钮",
    findings: "对抽查部位感烟探测器、手动报警按钮进行测试，报警功能正常，报警指示灯常亮。",
  },
  "item-13-sub-03": {
    sampleCount: "1",
    sampledLocations: "地下车库防火分区3、25号楼",
    findings: "现场查看故障报警显示位置准确，有声、光报警；现场查看探测器报警、手动报警显示位置准确，有声、光报警，切断非消防电源，排烟风机、补风机启动，防火分区处卷帘下降，电梯迫降首层，层门打开。",
  },
  "item-13-sub-04": {
    sampleCount: "1",
    sampledLocations: "消防控制室",
    findings: "本工程采用集中型火灾自动报警系统，消防控制室设备包括消防联动控制器、消防电源监控、电气火灾监控系统、图形显示等。",
  },
  "item-14-sub-01": {
    sampleCount: "2",
    sampledLocations: "地下防烟分区3-1、地下防烟分区9-2",
    findings: "抽查部位均采用机械排烟。",
  },
  "item-14-sub-02": {
    sampleCount: "2",
    sampledLocations: "地下防烟分区3-1、地下防烟分区9-2",
    findings: "排烟风机设置在排烟机房内，采用（双速）轴流式消防排烟风机，型号为GYF-9-S，流量为31500/24000m3/h，排烟风机供电情况：电源引自本防火分区内配电间排烟风机双电源供电回路。经现场测试，远程启动、本地手动启动、联动启动功能均可正常实现。",
  },
  "item-14-sub-03": {
    sampleCount: "2",
    sampledLocations: "地下防烟分区3-1、地下防烟分区9-2",
    findings: "管道采用钢面镁质防火风管，经查验型式检验报告等相关资料，排烟管道耐火极限不小于1h。",
  },
  "item-14-sub-04": {
    sampleCount: "2",
    sampledLocations: "地下防烟分区3-1、地下防烟分区9-2",
    findings: "经现场测试，远程启动、联动启动功能均可正常实现，风口气流方向及风速满足设计文件要求。",
  },
  "item-15-sub-01": {
    sampleCount: "1",
    sampledLocations: "建设单位提供供电方案",
    findings: "根据供电方案，本工程设计单位确认，本工程负荷等级为一级，供电采用双电源供电。",
  },
  "item-15-sub-02": {
    sampleCount: "1",
    sampledLocations: "柴发机房",
    findings: "柴发机房位于地下1层，耐火等级一级，采用耐火极限不低于2h的防火隔墙和不低于1.5h的楼板、甲级防火门与建筑的其他部分完全分隔，经测试应急照明功能正常，储油间设置符合设计文件要求。",
  },
  "item-15-sub-03": {
    sampleCount: "1",
    sampledLocations: "地下车库变配电室",
    findings: "采用耐火极限不低于2h的防火隔墙、耐火极限不低于1.5h的楼板和甲级防火门与建筑的其他部分完全分隔。应急照明系统采用辅助照明，经测试功能正常。",
  },
  "item-15-sub-04": {
    sampleCount: "2",
    sampledLocations: "消防水泵房、地库防火分区1配电室",
    findings: "现场消防用电设备设置专用供电回路；配电线路采用金属电缆桥架敷设。",
  },
  "item-15-sub-05": {
    sampleCount: "2",
    sampledLocations: "地下车库变配电室、防火分区3",
    findings: "开关、灯具等装置的发热情况和隔热、散热措施符合消防技术标准和消防设计文件要求。",
  },
  "item-16-sub-01": {
    sampleCount: "",
    sampledLocations: "",
    findings: "",
  },
  "item-16-sub-02": {
    sampleCount: "",
    sampledLocations: "",
    findings: "",
  },
  "item-17-sub-01": {
    sampleCount: "2",
    sampledLocations: "地下车库防火分区1、3变配电室",
    findings: "测试主、备电源切换正常；模拟自动启动系统，电磁阀动作正常，30s内有信号反馈。",
  },
};

export function getReportTemplateDefaults(subitemId: string): SubitemTemplateDefaults | null {
  return REPORT_TEMPLATE_DEFAULTS[subitemId] || null;
}
